import React from 'react';
import { useTranslation } from 'react-i18next';
import { WebTooltip as Tooltip } from '../../tooltip/web-tooltip';

export const ConsentRequiredAction: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { t } = useTranslation();

    return (
        <div data-consent-blocked className="w-full">
            <Tooltip content={t('layout.forms.common.agreeTermsValidation')} position="top" block>
                {children}
            </Tooltip>
        </div>
    );
};
